import {
  IAddUpdatePaiyaGiftPageState,
  IPaiyaUploadNormalizer,
} from "interfaces/Index";

export const normalizePaiyaGiftCreatePayload = (
  req: IAddUpdatePaiyaGiftPageState
): IPaiyaUploadNormalizer => {
  const payload: any = {
    type: req.type.id,
    title: req.title,
    details: {},
  };

  if (req.type.id === "COINS")
    payload.details.amount = parseFloat(req.value.toString());
  else if (req.type.id === "LUCKY_DRAW" || req.type.id === "PRODUCT")
    payload.details.variantId = req.value;

  // return payload

  const formData: any = new FormData();
  const imageData = (req.image! as any)?.multiPartData ?? "";

  formData.append("image", imageData);

  return { formData, payload };
};

export const normalizePaiyaGiftsList = (paiyaGifts: Array<any>) => {
  return paiyaGifts.map((gift: any) => ({
    id: gift.id,
    title: gift.title,
    type: gift.type,
    image: gift.image,
    value: gift.details?.amount ?? gift.details?.variantId,
  }));
};
